var React = require('react');
var objectAssign = require('object-assign');
module.exports = function (props) {
    return React.createElement('svg', objectAssign({}, {
        viewBox: '0 0 17 16',
        version: '1.1'
    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
        id: 'Projects',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none'
    }, React.createElement('g', {
        id: 'Project-Graph-View',
        transform: 'translate(-156.000000, -95.000000)',
        stroke: '#323232',
        strokeWidth: '2'
    }, React.createElement('g', {
        id: 'Back-Button',
        transform: 'translate(97.000000, 96.000000)'
    }, React.createElement('g', {
        id: 'XMLID_2_-+-Path-36',
        transform: 'translate(61.000000, 0.000000)'
    }, React.createElement('path', {
        d: 'M1,7 L15,7',
        id: 'XMLID_2_'
    }), React.createElement('path', {
        d: 'M7,0 L0,7 L7,14',
        id: 'Path-36'
    }))))));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-icon-loader!./app/images/ArrowBack.svg
// module id = 517
// module chunks = 1